import { useMemo } from "react";
import CommonTable from "../CommonTable";

const RainfallForecast = ({ tabularData = [], selectedDateIndex = 0 }) => {

  const getCharacteristic = (rainfall) => {
    if (rainfall !== null && rainfall !== undefined) {
      const rain = parseFloat(rainfall);
      if (isNaN(rain)) return "N/A";
      if (rain <= 20) return "NoRisk";
      if (rain <= 50) return "Low";
      if (rain <= 100) return "Medium";
      return "High";
    }
    return "N/A";
  };

  const rainfallKey = `rainfallDay${selectedDateIndex + 1}`;

  // ✅ map data for CommonTable
  const tableData = useMemo(() => {
    return tabularData.map((row) => {
      const rainfall = row[rainfallKey];
      const advisory = getCharacteristic(rainfall);

      return {
        municipality: row.municipality,
        subMunicipality: row.subMunicipality,
        Suco: row.Suco,
        // 0 mm is a valid value; only missing / non-numeric values are N/A
        rainfall: rainfall !== null && rainfall !== undefined && rainfall !== "" && !isNaN(parseFloat(rainfall))
          ? parseFloat(rainfall).toFixed(2) : "N/A",
        advisory, // 🔥 IMPORTANT
      };
    });
  }, [tabularData, rainfallKey]);

  // ✅ columns for CommonTable
  const columns = [
    { key: "SlNo", label: "Sl No" },
    { key: "municipality", label: "Municipality", sortable: true },
    { key: "subMunicipality", label: "Post Admin", sortable: true },
    { key: "Suco", label: "Suco", sortable: true },
    {
      key: "advisory",
      label: "Rainfall Type",
      render: (row, getColor) => (
        <span
          style={{
            background: getColor(row.advisory),
            padding: "3px 6px",
            borderRadius: "4px",
            fontWeight: "bold",
          }}
        >
          {row.advisory}
        </span>
      ),
    },
    { key: "rainfall", label: "Rainfall (mm)" },
  ];

  const legendColors = {
    High: "rgb(230,45,58)",
    Medium: "rgb(243,155,58)",
    Low: "rgb(243,235,18)",
    NoRisk: "rgb(148,203,85)",
  };

  return (
    <CommonTable
      tableData={tableData}
      columns={columns}
      showFilter
      filterOptions={["High", "Medium", "Low", "NoRisk", "All"]}
      legendColors={legendColors}
      searchableKeys={["municipality", "subMunicipality", "Suco"]}
      tableName="Rainfall_Forecast"
    />
  );
};

export default RainfallForecast;